/** The voices the 词典's recordings come in. */
export type ChartVoice = "female" | "male";

/**
 * The file one voice of a recording is in.
 *
 * The chart holds a recording as the address both voices share,
 * `/audio/cidian/妈/ma1/妈`, because every recording the 词典 makes is a pair
 * named that way (`src/audio/audio-paths.ts`). Writing both addresses out on
 * 1,267 tones was 60 KB of the page.
 * @param recording - The shared address.
 * @param voice - Which voice.
 * @returns The file.
 */
export function voiceFile(recording: string, voice: ChartVoice): string {
  return `${recording}_${voice}.mp3`;
}

/**
 * The address two files share, or undefined where they share none.
 * @param female - The female voice's file.
 * @param male - The male voice's file.
 * @returns What {@link voiceFile} turns back into each of them.
 */
export function sharedRecording(
  female: string,
  male: string,
): string | undefined {
  const recording = female.replace(/_female\.mp3$/u, "");

  return voiceFile(recording, "female") === female &&
    voiceFile(recording, "male") === male
    ? recording
    : undefined;
}

/**
 * What the chart plays where a reader asks for a tone it has no recording of.
 *
 * uisfx's `pause` from the `minimal` pack, the pack the 复习 sounds come from,
 * copied by `src/assets/feedback-sounds.ts`. A soft click that says the press
 * was heard and there was nothing to say, where silence leaves a reader
 * wondering whether the page is broken.
 */
export const chartSilenceFile = "chart-silence.mp3";

/** Where the page asks for {@link chartSilenceFile}. */
export const chartSilenceAddress = `/sounds/${chartSilenceFile}`;
